export default function Numpy_ArrayIterating() {
  return <div>Numpy_ArrayIterating Component</div>;
}
